import React, { Component } from 'react'
import classnames from 'classnames'
import InlineSVG from 'components/InlineSVG'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import './offcanvas.css'

class Offcanvas extends Component {
  constructor (props) {
    super(props)
    this.wrapper = null
  }

  render () {
    const { show, toggleOffcanvas, menu } = this.props
    return (
      <div className={classnames({
        'offcanvas': true,
        'offcanvas--show': show
      })} ref={wrapper => { this.wrapper = wrapper }}>
        <div className='offcanvas__header'>
          <Link
            to='/'
            className='offcanvas__logo'
            onClick={toggleOffcanvas}
          >
            LittleBox
          </Link>
          <InlineSVG icon='close' onClick={toggleOffcanvas} />
        </div>
        <div className='offcanvas__body'>
          {menu}
        </div>
      </div>
    )
  }
}

Offcanvas.propTypes = {
  show: PropTypes.bool.isRequired,
  toggleOffcanvas: PropTypes.func.isRequired,
  menu: PropTypes.node.isRequired
}

export default Offcanvas



// WEBPACK FOOTER //
// ./src/components/Page/Header/Offcanvas/index.js